// ==================================================
// MARKETING: Edit site-wide configuration here
// ==================================================

export const siteConfig = {
  name: 'PropertyForecast',
  tagline: 'Predict Property Values with AI',

  // Navigation menu items
  nav: [
    { label: 'Home', href: '/' },
    { label: 'For Investors', href: '/use-cases/investors' },
    { label: 'For Agents', href: '/use-cases/agents' },
  ],

  // Call-to-action buttons
  cta: {
    primary: 'Get Started',
    primaryLink: 'https://propertyforecast.co/?ref=hf',
    secondary: 'Learn More',
    secondaryLink: 'https://propertyforecast.co/?ref=hf',
  },

  // Social media links (optional)
  social: {
    twitter: 'https://twitter.com/propertyforecast',
    linkedin: 'https://linkedin.com/company/propertyforecast',
  },
}
